export default {
  required: '此欄位必須填寫',
  email: '請輸入有效的電子郵件地址',
  minLength: '此欄位至少需要{min}個字符',
  maxLength: '此欄位不能超過{max}個字符',
  min: '此欄位不能小於{min}',
  max: '此欄位不能大於{max}',
  numeric: '此欄位必須是數字',
  integer: '此欄位必須是整數',
  decimal: '此欄位必須是小數',
  url: '請輸入有效的網址',
  alpha: '此欄位只能包含字母',
  alphaNum: '此欄位只能包含字母和數字',
  alphaDash: '此欄位只能包含字母、數字、破折號和底線',
  alphaSpaces: '此欄位只能包含字母和空格',
  in: '此欄位必須是以下值之一：{values}',
  notIn: '此欄位不能是以下值之一：{values}',
  confirmed: '此欄位與確認欄位不匹配',
  different: '此欄位必須與{field}不同',
  same: '此欄位必須與{field}相同',
  between: '此欄位必須在{min}和{max}之間',
  before: '此欄位必須在{date}之前',
  after: '此欄位必須在{date}之後',
  dateFormat: '此欄位必須符合{format}格式',
  date: '此欄位必須是有效的日期',
  boolean: '此欄位必須是布林值',
  object: '此欄位必須是物件',
  array: '此欄位必須是陣列',
  string: '此欄位必須是字串',
  number: '此欄位必須是數字',
  regex: '此欄位格式無效',
  digits: '此欄位必須只包含數字',
  creditCard: '此欄位必須是有效的信用卡號碼',
  isbn: '此欄位必須是有效的ISBN',
  phone: '此欄位必須是有效的電話號碼',
  postalCode: '此欄位必須是有效的郵政編碼',
  ip: '此欄位必須是有效的IP地址',
  ipv4: '此欄位必須是有效的IPv4地址',
  ipv6: '此欄位必須是有效的IPv6地址',
  macAddress: '此欄位必須是有效的MAC地址',
  uuid: '此欄位必須是有效的UUID',
  ascii: '此欄位只能包含ASCII字符',
  base64: '此欄位必須是有效的Base64字串',
  byteLength: '此欄位長度必須在{min}和{max}字節之間',
  dataUri: '此欄位必須是有效的Data URI',
  mimeType: '此欄位必須是有效的MIME類型',
  ext: '此欄位必須是以下檔案類型之一：{extensions}',
  fileSize: '此欄位大小必須在{min}和{max}之間',
  image: '此欄位必須是有效的圖片檔案',
  video: '此欄位必須是有效的影片檔案',
  audio: '此欄位必須是有效的音訊檔案',
  dimensions: '此欄位必須是{width}x{height}像素的圖片',
  fieldNames: {
    username: '用戶名',
    email: '電子郵件',
    password: '密碼',
    confirmPassword: '確認密碼',
    firstName: '名字',
    lastName: '姓氏',
    phone: '電話',
    address: '地址',
    city: '城市',
    state: '州/省',
    country: '國家',
    postalCode: '郵政編碼',
    website: '網站',
    description: '描述',
    title: '標題',
    content: '內容',
    category: '分類',
    tags: '標籤',
    price: '價格',
    quantity: '數量',
    rating: '評分',
    comment: '評論',
    search: '搜尋',
    message: '訊息',
    subject: '主旨',
    name: '姓名',
    company: '公司',
    position: '職位',
    department: '部門',
    birthday: '生日',
    gender: '性別',
    language: '語言',
    timezone: '時區',
    currency: '貨幣',
    paymentMethod: '付款方式',
    cardNumber: '卡號',
    cardExpiry: '卡片到期日',
    cardCvv: '卡片驗證碼',
    terms: '條款',
    privacy: '私隱',
    newsletter: '電子報',
    notifications: '通知',
    avatar: '頭像',
    bio: '個人簡介',
    social: '社交媒體',
    preferences: '偏好設定'
  }
}; 